import { useSearchParams } from 'next/navigation'
import { SalaryType } from '@/lib/generated/graphql-types'
import { SalaryFilterParam } from '../constants'

export function useSalaryDetails({ salaries }: { salaries: SalaryType[] }) {
  const searchParams = useSearchParams()
  const salaryId = searchParams.get(SalaryFilterParam.salaryId)
  const salary = salaries?.find((s) => s.salaryId === salaryId)
  return { salary }
}
